import { render, staticRenderFns } from "./orderInvoiceDetail.vue?vue&type=template&id=5ec4abce&"
import script from "./orderInvoiceDetail.vue?vue&type=script&lang=js&"
export * from "./orderInvoiceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports